import { Button, Card, message, Radio } from "antd";
import { useCreateWeighBride } from 'features/master/use-cases/create-weighbride';
import { useGetWeightBridgeList } from "features/master/use-cases/get-weightBridge"
import { useEffect, useState } from "react";
import { SideBarMenus } from "routes/constants";
import { HasPermission } from "utils/CheckPermissions";

export const WeighBridge = () => {

  const { mutate } = useCreateWeighBride();
  const { data } = useGetWeightBridgeList(1);
  const [selected, setSelected] = useState(
    data?.rc?.find(item => item.isDefault)?.id
  );

  useEffect(() => {
    const defaultId = data?.rc?.find(item => item.isDefault)?.id;
    if (defaultId !== undefined) {
      setSelected(defaultId);
    }
  }, [data?.rc]);
  const handleSubmit = () => {
    if (selected === null) {
      message.warning("Please select a WeighBridge option!");

      return;
    }

    const payload: any = {
      weighBridgeIds: selected === 0 ? [0] : [selected], // 0 for "All"
    };
    mutate(payload); // 🔥 hit API
    message.success(`API hit for WeighBridge ${selected === 0 ? "All" : selected}`);
  };

  return (
    <div className="p-12 flex ">
      <Card title="WeighBridge Priority" >
        <Radio.Group
          onChange={(e) => setSelected(e.target.value)}
          value={selected}
          className="flex flex-col gap-3"
        >
          {data?.rc && data.rc.length > 0 && data.rc.map((t) => (
            <Radio key={t.Id} value={t.id}>
              {t.title}
            </Radio>
          ))}


        </Radio.Group>

          {HasPermission(SideBarMenus.WBPRIORITY, 'edit')?(
        <Button
          type="primary"
          className="mt-6 w-full"
          onClick={handleSubmit}
        >
          Submit
        </Button>
          ):null }

      </Card>
    </div>
  );
};
